const { getHashSha256 } = require('@aok/hash-functions')

/**
 * Returns the key of an environment variable, which is a SHA-256 hash based upon a plaintext key defined in /apis.js
 * @param {string} key
 * @returns {string}
 */
const getEnvironment = (key) => getHashSha256(key)

module.exports = {
  getEnvironment,
}
